import { FlagsmithFeatureFlagNavigationResolver } from "../flagsmith/providers/flagsmith-feature-flag-navigation.resolver";
import type { NerriNavigationItem } from "./models/navigation-items.model";

export const ContractorNavigationItems: NerriNavigationItem[] = [
    {
        id: "pumping_management",
        module: "pumping_management",
        type: "group",
        title: "navigation.pumping_management",
        children: [
            {
                id: "pumping-contracts",
                title: "navigation.pumping_visits.clients",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:business-deal-handshake",
                link: "/dashboard/pumping-contract"
            },
            {
                id: "manage-pumping-visits",
                title: "navigation.pumping_visits.manage",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:calendar",
                link: "/dashboard/pumping-visit/manage"
            },
            {
                id: "pumping-visits-list",
                title: "navigation.pumping_visits.history",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:gardening-watering-pipe",
                link: "/dashboard/pumping-visit/history"
            },
            {
                id: "pumping-visits-list-history",
                title: "navigation.pumping_visits.truck",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:truck-cargo-1",
                link: "/dashboard/pumping-visit/truck"
            }
        ]
    },
    {
        id: "septage_management",
        module: "septage_management",
        type: "group",
        title: "navigation.septage_management",
        children: [
            {
                id: "manage-septage-measurement-visits",
                title: "navigation.septage_measurement_visits.manage",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:calendar",
                link: "/dashboard/septage-measurement-visit/manage"
            },
            {
                id: "septage-measurement-visits-history",
                title: "navigation.septage_measurement_visits.history",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:ruler",
                link: "/dashboard/septage-measurement-visit/history"
            }
        ]
    },
    {
        id: "maintenance_management",
        module: "maintenance_management",
        type: "group",
        title: "navigation.maintenance_management",
        children: [
            {
                id: "manage-maintenance-visits",
                title: "navigation.maintenance_visits.manage",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:calendar",
                link: "/dashboard/maintenance-visit/manage"
            },
            {
                id: "maintenance-visits-list-history",
                title: "navigation.maintenance_visits.history",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:tools-box",
                link: "/dashboard/maintenance-visit/history"
            }
        ]
    },
    {
        type: "divider"
    },
    {
        id: "user",
        module: "users_management",
        title: "navigation.users",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:multi-neutral-2",
        link: "/dashboard/user"
    },
    {
        id: "settings",
        title: "navigation.settings",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:cog-double-2",
        link: "/dashboard/setting",
        hidden: FlagsmithFeatureFlagNavigationResolver,
        meta: {
            featureKey: "contractor_settings_access"
        }
    }
];
